import type { Directory } from 'shared/types/file-storage-types';

export const fileStorageQueryKeys = {
  fileStorage: ['file-storage'],
  projectBackups: (slug: string) => [...fileStorageQueryKeys.fileStorage, slug],
};

export const filesQueryKeys = {
  files: ['files'],
  projectFilesTab: (slug: string, tab: Directory) => [
    ...filesQueryKeys.files,
    slug,
    tab,
  ],
  projectFilesGit: (
    slug: string,
    tab: Directory,
    branch: string,
    path: string
  ) => [...filesQueryKeys.files, slug, tab, branch, path],
};
